import React from 'react';
import CountUp from 'react-countup';
import { useReducedMotion } from 'framer-motion';

/**
 * Animated number that counts up or down whenever `value` changes.
 */
function LivePointsNumber({ value, className = '', duration = 0.65 }) {
  const reducedMotion = useReducedMotion();
  const n = Number(value);
  const end = Number.isFinite(n) ? n : 0;

  return (
    <span className={className}>
      <CountUp
        end={end}
        duration={reducedMotion ? 0 : duration}
        preserveValue
        separator=","
        useEasing
      />
    </span>
  );
}

export default LivePointsNumber;
